import * as Sentry from '@sentry/vue';

export const initSentry = (app: any) => {
  const {NODE_ENV} = process.env;
  if (NODE_ENV !== 'development') {
    Sentry.init({
      app,
      dsn: 'https://e713da7b152a4f71a355903bc3d5d03c@sentry.baijia.com/1019',
      environment: NODE_ENV,
      // integrations: [
      //   new BrowserTracing({
      //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      //     tracingOrigins: ['test-m.gaotu.cn', 'm-gaotu.cn'],
      //   }),
      // ],
      tracesSampleRate: 1.0,
    });
  }
};
